import * as React from 'react';

import { colors } from '../colors/color';
import styled from 'styled-components';


type OnOffProps = {
    active:boolean,
    text?:{width:number, active:string, inactive:string},
    variant?: 'default' | 'fullColor',
    size?: 'small' | 'medium' | 'large',
    onClick?:(active:boolean)=>void,
    disabled?:boolean
}

export function OnOff(props:OnOffProps):JSX.Element
{
    function handleToggle(){
        if(props.disabled) 
            return;

        props.onClick(!props.active);
    }

    function handleKeyDown(e:React.KeyboardEvent<HTMLDivElement>)
    {
        if(e.key === 'Enter' || e.key === ' ')
            handleToggle();
    }

    return (
        <OnOffWrapper disabled={props.disabled} active={props.active} onClick={handleToggle} onKeyDown={handleKeyDown} variant={props.variant} width={props.text ? props.text.width : undefined} size={props.size} role="button" tabIndex={0}>
            {props.text && 
                <span>{props.active ? props.text.active : props.text.inactive}</span>
            }
        </OnOffWrapper>
    );
}




function WrapperVariant(variant:string, active:boolean)
{
    let color, background;
    switch(variant)
    {
        case 'fullColor':
            color = active ? colors.onOff.fullColor.activeColor : colors.onOff.fullColor.inactiveColor;
            background = active ? colors.onOff.fullColor.activeBackground : colors.onOff.fullColor.inactiveBackground;
            return `color: ${color}; background: ${background};`;
        default:
            color = active ? colors.onOff.default.activeColor : colors.onOff.default.inactiveColor;
            background = active ? colors.onOff.default.activeBackground : colors.onOff.default.inactiveBackground;
            return `color: ${color}; background: ${background};`;
    }
}


function OnOffSize(size:string){
    switch(size)
    {
        case 'small':
            return 12;
            
        case 'medium':
            return 18;

        case 'large':
            return 30;

        default:
            return 18;
    }
}


const OnOffWrapper = styled.div<{active:boolean, disabled:boolean, size:string, variant:string, width:number}>`

    height: ${props => OnOffSize(props.size) + 4}px;

    align-items: center;
    border: ${props => props.active ? colors.onOff.border : colors.onOff.inactiveBorder};;
    border-radius: ${props => OnOffSize(props.size) + 2}px;
    cursor: pointer;
    
    justify-content: center;
    min-width: ${props => OnOffSize(props.size) * 2}px;
    display: flex;
    padding:2px;
    width: ${props => props.width ? props.width + 'px' : OnOffSize(props.size) * 2 + "px"};
    ${props => WrapperVariant(props.variant, props.active)};
    
    ${props => props.disabled && `background: ${colors.inputState.disabled.background};`}
    ${props => props.disabled && `color: ${colors.inputState.disabled.text};`}
    ${props => props.disabled && `cursor: not-allowed;`}

    transition: all .25s ease-in;
    position:relative;

    user-select: none;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.25) inset;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.25) inset;
    -moz-box-shadow: 0px 0px 5px 0px rgba(143, 136, 136, 0.25) inset;

    & span {
        margin-left: ${props => props.active ? '0px' : `${OnOffSize(props.size) - 10}px`};
        margin-right: ${props => props.active ? `${OnOffSize(props.size) - 10}px` : '0px' };
        
        
    }

    &::before {
        content: '';
        ${props => props.disabled ? 
            `border: 1px solid ${colors.inputState.disabled.border};` : 
            `border: 1px solid rgb(160, 160, 160);`
        }
        
        border-radius: 50%;
        width: ${props => OnOffSize(props.size)}px;
        height: ${props => OnOffSize(props.size)}px;;
        transition: all .1s ease-in;
        position: absolute;
        ${props => props.active ? `left: calc(100% - ${OnOffSize(props.size) + 1}px);` : 'left: 2px;'};
        ${props => props.disabled ? 
            `background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(226,226,226,1) 100%);` : 
            `background: linear-gradient(0deg, rgba(230,230,230,1) 0%, rgba(200,200,200,1) 100%);`
        }
        
        top: 2px;
    }
`